export default function LoadingScreen() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "#0e1018",
        color: "#d6d9e0",
        fontFamily: "-apple-system,system-ui,sans-serif",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          aria-hidden="true"
          style={{
            width: 32,
            height: 32,
            border: "3px solid #2a2f3a",
            borderTopColor: "#7aa2ff",
            borderRadius: "50%",
            margin: "0 auto 0.75rem",
            animation: "thunderay-spin 0.8s linear infinite",
          }}
        />
        <p style={{ opacity: 0.7, fontSize: "0.9rem", margin: 0 }}>Loading…</p>
        <style>{`@keyframes thunderay-spin{to{transform:rotate(360deg)}}`}</style>
      </div>
    </div>
  );
}
